// apps/web/src/layouts/components/SidebarApprovalsBadge.tsx
//
// Badge de pendências do Pricing (Produtos e preços > Precificação > Aprovações).
// O número vem de `useSidebarBadgeCounts()`, montado uma vez no topo da sidebar
// admin — este componente só decide rótulo e visual.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarApprovalsBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarApprovalsBadge({ count, variant }: SidebarApprovalsBadgeProps) {
  const { t } = useTranslation('admin');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-approvals-badge"
      label={t('sidebar.badges.pricing_pending', { count })}
    />
  );
}
